"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildThemeVariables = void 0;
const colors_1 = require("../utils/colors");
const common_1 = require("./common");
exports.default = (0, common_1.createTheme)((defaults) => {
    const colorScheme = {
        background: defaults.colors.absolute.white,
        bgMinor: defaults.colors.warmGray[100],
        bgInvert: defaults.colors.warmGray[550],
        control: defaults.colors.yellow.toxic,
        controlText: defaults.colors.warmGray[600],
        controlMinor: (0, colors_1.hexToRgba)(defaults.colors.warmGray[450], 0.1),
        controlMinorText: defaults.colors.warmGray[600],
        text: defaults.colors.warmGray[600],
        textMinor: defaults.colors.warmGray[300],
        textInvert: defaults.colors.absolute.white,
        textLink: defaults.colors.shamelessBlue.normal,
        line: (0, colors_1.hexToRgba)(defaults.colors.warmGray[350], 0.4),
        fog: (0, colors_1.hexToRgba)((0, colors_1.invertHex)(defaults.colors.absolute.white), 0.5),
        error: defaults.colors.red.toxic,
        success: defaults.colors.green.normal,
        warning: defaults.colors.orange.normal,
        info: defaults.colors.blue.normal,
        everBlack: defaults.colors.absolute.black,
        everWhite: defaults.colors.absolute.white,
    };
    return Object.assign(Object.assign({}, defaults), buildThemeVariables(colorScheme));
});
function buildThemeVariables(colorScheme) {
    return {
        colorScheme,
        shadows: {
            bottomNormal: `0px 8px 20px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.12)}`,
            bottomClose: `0px 2px 5px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)}`,
            topNormal: `0px -4px 20px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.12)}`,
        },
        components: {
            slots: {
                size: {
                    xs: 32,
                    s: 40,
                    m: 48,
                    l: 56,
                },
            },
            listItems: {
                divider: (0, colors_1.changeAlpha)(colorScheme.line, 0.2),
                dividerDisabled: (0, colors_1.changeAlpha)(colorScheme.line, 0.4),
                bgColorHovered: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                bgColorPressed: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)),
                borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
            },
            buttons: {
                loadingGradient: `
                    linear-gradient(
                        90deg,
                        ${(0, colors_1.hexToRgba)(colorScheme.background, 0)} 0,
                        ${(0, colors_1.hexToRgba)(colorScheme.background, 0.2)} 20%,
                        ${(0, colors_1.hexToRgba)(colorScheme.background, 0.8)} 60%,
                        ${(0, colors_1.hexToRgba)(colorScheme.background, 0)}
                    )`,
                default: {
                    bgColorHovered: (0, colors_1.blend)(colorScheme.controlMinor, (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                    bgColorPressed: (0, colors_1.blend)(colorScheme.controlMinor, (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)),
                    borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
                },
                action: {
                    bgColorHovered: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.control), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                    bgColorPressed: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.control), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)),
                    borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
                },
                outline: {
                    bgColor: (0, colors_1.hexToRgba)(colorScheme.background, 0),
                    bgColorHovered: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                    bgColorPressed: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1),
                    borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
                    border: '1px solid var(--colorScheme-line)',
                },
                floating: {
                    bgColorHovered: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                    bgColorPressed: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                    borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
                },
                ghost: {
                    bgColor: (0, colors_1.hexToRgba)(colorScheme.background, 0),
                    bgColorHovered: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                    bgColorPressed: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1),
                    borderFocused: `2px solid ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.75)}`,
                },
            },
            switches: {
                hoveredColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                buttonShadow: `0px 2px 5px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)}`,
            },
            checkboxes: {
                hoveredColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
            },
            tabs: {
                pressedColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1),
                hoveredColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
            },
            skeleton: {
                bgInvertColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                bgTransparentColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0),
            },
            textFields: {
                outline: {
                    bgColorError: colorScheme.controlMinor,
                },
            },
            tooltips: {
                shadowFilter: `drop-shadow(0px 0px 1px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.15)}) drop-shadow(0px 8px 20px ${(0, colors_1.hexToRgba)(colorScheme.everBlack, 0.12)})`,
            },
            calendars: {
                textColorSelected: 'var(--colorScheme-text)',
                hoveredOverlayColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                pressedOverlayColor: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1),
                hoveredOverlayColorSelected: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05),
                pressedOverlayColorSelected: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1),
            },
            tables: {
                bgColorHovered: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.05)),
                bgColorPressed: (0, colors_1.blend)((0, colors_1.hexToRgba)(colorScheme.background), (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.1)),
                borderBody: `1px solid ${(0, colors_1.changeAlpha)(colorScheme.line, 0.2)}`,
                borderHeader: `1px solid ${(0, colors_1.hexToRgba)(colorScheme.text, 0.5)}`,
                columnShadow: `0px 0px 20px ${(0, colors_1.hexToRgba)(colorScheme.text, 0.12)}`,
            },
            modal: {
                scrollShadow: (0, colors_1.hexToRgba)(colorScheme.everBlack, 0.12),
                transparent: (0, colors_1.hexToRgba)(colorScheme.background, 0),
            },
        },
    };
}
exports.buildThemeVariables = buildThemeVariables;
